import logo from './logo.svg';
//import './App.css';
import './scss/puzztime.scss';
import React, { useState, useEffect, useRef } from 'react'; 
import Casilla from './components/Casilla';
import Numero from './components/Numero';
import { initializeApp } from "firebase/app";
import { getAnalytics,logEvent } from "firebase/analytics";

import Confetti from 'react-confetti';
import { useWindowSize } from 'react-use';
import Rand, { PRNG } from 'rand-seed';
import { BrowserRouter, Routes, Route, Link, useLocation, useNavigate, useParams  } from 'react-router-dom';
//import IonIcon from '@reacticons/ionicons';
import Header from './components/Header';
import Victoria from './components/Victoria';
import TiemposCont from './components/TiemposCont';
import juegos from './assets/juegos.json';
import { getFirestore ,collection, getDocs ,addDoc, updateDoc, deleteDoc, doc ,getDoc, setDoc} from "firebase/firestore";
import ObtFraseFin from './Utilidades';
import AbajoJuegos from './components/AbajoJuegos';



function Sudoku() {
const params = useParams();

  const firebaseConfig = {
  apiKey: "AIzaSyCceVPpjBFbA_khqjXABlFtdex6wU6YWPM",
  authDomain: "everyday---deia.firebaseapp.com",
  projectId: "everyday---deia",
  storageBucket: "everyday---deia.firebasestorage.app",
  messagingSenderId: "789110585317",
  appId: "1:789110585317:web:5d01114092fe374edce10c",
  measurementId: "G-N0EC1VFRC5"
};
var rand:Rand;
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);

const navigate = useNavigate();
const [juegoAct, setJuegoAct]=useState(juegos[2]);
const [casillaSelec, setCasillaSelec]=useState({ numero: 0, estado: 0 });
const [confettiVisible, setConfettiVisible] = useState(false); 
const [iniciado, setIniciado] = useState(false);
const [modoCandidatos, setModoCandidatos] = useState(false);
const [secondsElapsed, setSecondsElapsed] = useState<number>(0);
const [timerRunning, setTimerRunning] = useState<boolean>(false);
const [gameWon, setGameWon] = useState<boolean>(false);

const [medalla, setMedalla] = useState(-1);
const [media, setMedia] = useState(-1);
const [porcentajeSuperado, setPortentajeSuperado] = useState(-1);

const [fechaAct,setFechaAct]=useState(new Date());
const [fechaTexto,setFechaTexto]=useState("");
const audioWon = new Audio('./sounds/won.mp3');
const audioWrong = new Audio('./sounds/error.mp3');
const audioTocar = new Audio('./sounds/toca_casilla.mp3');
const [fraseSeleccionada, setFraseSeleccionada]=useState(""); 


 const today = new Date().toLocaleDateString('es-ES', {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
  }).toUpperCase();






  useEffect(() => {
    let interval: NodeJS.Timeout;
    if (timerRunning) {
      interval = setInterval(() => {
        setSecondsElapsed((prev) => prev + 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [timerRunning]);


const [matrix, setMatrix]= useState(Array(9).fill(0).map((row,index) =>      
    new Array(9).fill({ numero_r: -1, bloqueado: 0, fil:0, col:0, num_act:-1  , seleccionado:0, conflicto:0, iNumCuadrado9:-1}) 
))
const [numeros, setNumeros]= useState(
    Array(10).fill({ numero: 0, estado: 0 }) // 0 = no tocada, 1 = incorrecta, 2 = correcta
  );

if (!iniciado) {
    IniciarSudoku();
}

function IniciarSudoku() {
  const dayNames = ["Domingo", "Lunes", "Martes","Miércoles","Jueves","Viernes","Sabado"];
  let params = useParams();
  var today = new Date();
  //alert(today.toLocaleDateString('en-US'));
  //alert("Días "+params.dia);
  var numDias=parseInt(params.dia!);
  today.setDate(today.getDate() - numDias);
  //alert(today.toLocaleDateString('en-US'));
  rand=new Rand(today.toLocaleDateString('en-US'));
  
  const sudoku = generateSudoku();
  //printBoard(sudoku);

  if(numDias==0){
    setFechaTexto("Hoy, "+today.getDate());
  }
  else if(numDias==1){
    setFechaTexto("Ayer "+today.getDate());
  }else{
    setFechaTexto(dayNames[today.getDay()] + " "+today.getDate());
  }
  setFechaAct(today);
  

  let nMatrix = [...matrix];
  for(let col=0; col<9; col++){
    let columnaAct=matrix[col];
    for(let fil=0; fil<9; fil++){
      let casilla=columnaAct[fil];
      let cuadrado9=Math.floor(col / 3) + Math.floor(fil / 3) * 3;
      console.log(">cuadrado9 "+col+" "+fil+"  -> "+cuadrado9);
      casilla={ numero_r: sudoku[fil][col], bloqueado: 1, fil:fil, col:col, num_act:sudoku[fil][col] , seleccionado:0, conflicto:0,iNumCuadrado9:cuadrado9 , candidatos:[0,0,0,0,0,0,0,0,0]};
      columnaAct[fil]=casilla;
    }
    matrix[col]=columnaAct;
  }

  let nNumeros=[...numeros];
  for(let i=1;i<11;i++){
    if(i==10){
      nNumeros[i-1]={numero: -1, estado: 0 };
    }else{
      nNumeros[i-1]={numero: i, estado: 0 };
    }
    
  }


  setIniciado(true);
  setNumeros(nNumeros);
  setTimerRunning(true);
  setMatrix(nMatrix);
  console.log(matrix);

  //ocultar casillas
  OcultarCasillas();

  if(localStorage.getItem("medalla_sudoku_"+today.getFullYear()+"-"+(today.getMonth()+1)+"-"+today.getDate())==null){
      //alert("sin jugar");
    }else{
      //alert("Ya jugado "+localStorage.getItem("medalla_parejas_"+today.getFullYear()+"-"+(today.getMonth()+1)+"-"+today.getDate()));
      
      setTimeout(function () {
              navigate("/dias/sudoku");
      }, 50);
      
    }

}




  const formatClock = (totalSeconds: number): string => {
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  };


function OcultarCasillas() {
  let casillasOcultas=33;
  console.log("<Ocultar casillas "+casillasOcultas);

  let lCasillasOcultar=new Array();

  for(let col=0; col<9; col++){
    for(let fil=0; fil<9; fil++){
      lCasillasOcultar.push(matrix[col][fil]);
    }
  }

  while(lCasillasOcultar.length>casillasOcultas){
    lCasillasOcultar.splice(RandomNumber(0,lCasillasOcultar.length-1), 1);
  }

  for(let i=0; i<lCasillasOcultar.length;i++){
    lCasillasOcultar[i].bloqueado=0;
    lCasillasOcultar[i].num_act=-1;
  }
  ClickCasilla(lCasillasOcultar[0],false);
  console.log(matrix);
}


function createEmptyBoard() {
  return Array.from({ length: 9 }, () => Array(9).fill(0));
}

function shuffle(array:any) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(rand.next() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}

function isValid(board:any, row:any, col:any, num:any) {
  // Verificar fila y columna
  for (let i = 0; i < 9; i++) {
    if (board[row][i] === num || board[i][col] === num) return false;
  }

  // Verificar subcuadro 3x3
  const startRow = Math.floor(row / 3) * 3;
  const startCol = Math.floor(col / 3) * 3;

  for (let i = 0; i < 3; i++) {
    for (let j = 0; j < 3; j++) {
      if (board[startRow + i][startCol + j] === num) return false;
    }
  }

  return true;
}

function RandomNumber(min : any, max: any) {
  return Math.floor(rand.next() * (max - min + 1)) + min;
}

function solveBoard(board:any) {
  for (let row = 0; row < 9; row++) {
    for (let col = 0; col < 9; col++) {
      if (board[row][col] === 0) {
        const numbers = shuffle([1, 2, 3, 4, 5, 6, 7, 8, 9]);
        for (let num of numbers) {
          if (isValid(board, row, col, num)) {
            board[row][col] = num;
            if (solveBoard(board)) return true;
            board[row][col] = 0;
          }
        }
        return false; // No solución encontrada para esta casilla
      }
    }
  }
  return true; // Tablero resuelto
}

function generateSudoku() {
  const board = createEmptyBoard();
  solveBoard(board);
  return board;
}



function printBoard(board:any) {
  console.log('-------------------------');
  for (let i = 0; i < 9; i++) {
    let row = '';
    for (let j = 0; j < 9; j++) {
      row += board[i][j] + ' ';
      if ((j + 1) % 3 === 0 && j < 8) row += '| ';
    }
    console.log(row.trim());
    if ((i + 1) % 3 === 0 && i < 8) {
      console.log('-------------------------');
    }
  }
}

function ClickNum(numero:any){
  console.log("<Click ");
  audioTocar.play();
  const nCasillaSelec:any = casillaSelec;
  if(nCasillaSelec!== null){
    if(modoCandidatos){
      console.log("<Candidato "+numero.numero);
      if(nCasillaSelec.candidatos[numero.numero-1]==0){
        nCasillaSelec.candidatos[numero.numero-1]=1;
      }else{
        nCasillaSelec.candidatos[numero.numero-1]=0;
      }
      console.log(nCasillaSelec.candidatos);
      setCasillaSelec(nCasillaSelec);
      let nMatrix=[...matrix];
      setMatrix(nMatrix);
      //nCasillaSelec.num_act=numero.numero;
      
    }else{
      console.log("<Set "+numero.numero);
      nCasillaSelec.num_act=numero.numero;
      setCasillaSelec(nCasillaSelec);
      let nMatrix=[...matrix];
      setMatrix(nMatrix);
      ComprobarSudoku();
    }
    
  }
}

function ClickCasilla(casilla:any, sonar:any){
  if(sonar){
    audioTocar.play();
  }
  if(casilla.bloqueado===1){
    return;
  }
  const nCasillaSelec:any = casillaSelec;
  if(nCasillaSelec!== null){
    nCasillaSelec.seleccionado=0;

  }
  casilla.seleccionado=1;
  setCasillaSelec(casilla);
  let nMatrix=[...matrix];
  setMatrix(nMatrix);

}

function ComprobarSudoku(){
  let faltaAlgo = false;
  let algunError = false;

  for(let col=0; col<9; col++){
    for(let fil=0; fil<9; fil++){
      let casilla=matrix[col][fil];
      if(casilla.num_act<1){
        faltaAlgo=true;
      }
      casilla.conflicto=CasillaConConflicto(casilla);
      if(casilla.conflicto==1){
        algunError=true;
      }
    }
  }
  if(algunError){
    audioWrong.play();
  }
      
  console.log("COMPROBAR SUDOKU faltaAlgo:"+faltaAlgo+" algunError:"+algunError);

  if(faltaAlgo==false && algunError == false)
  {
      Resuelto();
  }
}

function Resuelto(){
  audioWon.play();
  setTimerRunning(false);
  
  setConfettiVisible(true);
  getTimes(secondsElapsed);
  setTimeout(() => {
      setGameWon(true);
        //Reiniciar(); // Iniciar fade (opacidad)
      }, 2000);
}

function Reiniciar(){
    window.location.reload();
  }

function MostrarIntertitial(){
  //interstitial();
}
function MostrarRewarded(){
  //rewardVideo();
}

function SetModoNumeros(){
  setModoCandidatos(false);
  console.log('SetModoNumeros');
}

function SetModoCandidatos(){
  setModoCandidatos(true);
  console.log('SetModoCandidatos');
}


function ClickBack(){
  //navigate("/dias/sudoku");
  AbrirLateral();
}

function AbrirLateral(){
    document.getElementById("lateral-juegos")!.style.left = "0px";
    document.getElementById("lateral-juegos")!.style.boxShadow = "4px 0 20px rgba(0,0,0,0.08)";
    document.getElementById("lateral-overlay")!.style.opacity = "1";
    document.getElementById("lateral-overlay")!.style.pointerEvents = "auto";
}

function Continuar(){
    //window.location.reload();
    navigate("/dias/sudoku");
  }

const getTimes = async (tiempo: number) => {
    const docRef = doc(db, "tiempos_sudoku", fechaAct.getFullYear()+"-"+(fechaAct.getMonth()+1)+"-"+fechaAct.getDate())
    const docSnap = await getDoc(docRef)
    let porcentajeS=100;
    if (docSnap.exists()) {
       console.log("Document data:", docSnap.data())
       let data=docSnap.data();

       let media=0;
       let contSuperado=0;

       for(var i=0; i<data.tiempos.length; i++){
          media=media+data.tiempos[i];
          if(data.tiempos[i]>=tiempo){
            contSuperado++;
          }
       }
       let medallaAct=0;
       media=media/data.tiempos.length;
       porcentajeS=(contSuperado/data.tiempos.length)*100;
       if(porcentajeS>=90){
        medallaAct=3;
       }else if(porcentajeS>=70){
        medallaAct=2;
       }else if(porcentajeS>=50){
        medallaAct=1;
       }else{
        medallaAct=0;
       }
       setMedalla(medallaAct);
       localStorage.setItem("medalla_sudoku_"+fechaAct.getFullYear()+"-"+(fechaAct.getMonth()+1)+"-"+fechaAct.getDate(),""+medallaAct);

       setPortentajeSuperado(porcentajeS);
       setMedia(media);
       console.log("Media -> "+media+" portentaje -> "+porcentajeS+" contSuperado ->"+contSuperado);
       data.tiempos.push(tiempo);
       setDoc(doc(db, "tiempos_sudoku", fechaAct.getFullYear()+"-"+(fechaAct.getMonth()+1)+"-"+fechaAct.getDate()), data);


      //setUser(docSnap.data())
    } else {
      // doc.data() will be undefined in this case
      console.log("No such document!");
      const data = {
        tiempos:[tiempo]
      };
      porcentajeS=100;
      localStorage.setItem("medalla_sudoku_"+fechaAct.getFullYear()+"-"+(fechaAct.getMonth()+1)+"-"+fechaAct.getDate(),""+3);
      setDoc(doc(db, "tiempos_sudoku", fechaAct.getFullYear()+"-"+(fechaAct.getMonth()+1)+"-"+fechaAct.getDate()), data);
      setMedalla(3);
      setMedia(tiempo);
      setPortentajeSuperado(100);
    }
    setFraseSeleccionada(ObtFraseFin(porcentajeS));
  }

function CasillaConConflicto(casilla:any){
  if(casilla.num_act===-1){
    return 0;
  }

  for(let col=0; col<9; col++){
    for(let fil=0; fil<9; fil++){
      let casillaAct=matrix[col][fil];
      if(casillaAct!=casilla){
        if (casillaAct.num_act == casilla.num_act &&
          (casillaAct.fil == casilla.fil ||
          casillaAct.col == casilla.col ||
          casillaAct.iNumCuadrado9 == casilla.iNumCuadrado9))
          {
              return 1;
          }
      }

    }
  }

    return 0;


}

  return (
  
    <div className={"puzztime " + juegoAct.nombre}>


      {/* --------------------- HEADER --------------------- */}

      <Header nombre={juegoAct.nombre} color={juegoAct.color} clicked={() => ClickBack()} ></Header>


      <div className="game-area">
       {/* --------------------- GAME META --------------------- */}

      <TiemposCont fechaTexto={fechaTexto} secondsElapsed={formatClock(secondsElapsed)}></TiemposCont>

    {/* --------------------- GAME CONTENT --------------------- */}

    <main className="game-content">
      <div className="sudoku-board">
        {matrix.map((row, index) => (
          <div className="rowsudoku" key={index}>
            {row.map((casilla, index2) => (
                <Casilla casilla={casilla} key={index2} clicked={() => ClickCasilla(casilla,true)}/>
            ))}
          </div>
          ))}
      </div>

      {/* --------------------- MODOS NORMAL / CANDIDATOS --------------------- */}

      <div className="sudoku-mode">
        <button className={"boton-ad  "+ (modoCandidatos===false? 'modoSeleccionado ' :'')} onClick={SetModoNumeros}>Números</button>
        <button className={"boton-ad  "+ (modoCandidatos===true? 'modoSeleccionado ' :'')} onClick={SetModoCandidatos}>Candidatos</button>
      </div>

      <div className="numeros">
      {numeros.map((numero, index) => (
        <Numero numero={numero} key={index} clicked={() => ClickNum(numero)} modoCandidatos={modoCandidatos} casillaAct={casillaSelec}/>
       ))}
      </div>
    </main>

        {/* Mensaje de victoria */}
        {gameWon &&(
          <Victoria
            nombre={juegoAct.nombre}
            color={juegoAct.color}
            today={today}
            fraseSeleccionada={fraseSeleccionada}
            secondsElapsed={formatClock(secondsElapsed)}
            medalla={medalla}
            media={media}
            porcentajeSuperado={porcentajeSuperado}
            clickContinuar={Continuar}
            icono={juegoAct.icono}
            idJuego={3}
            ></Victoria>
          )}
      </div>

      {confettiVisible && (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999, pointerEvents: 'none' }}>
        <Confetti
          width={window.innerWidth}
          height={window.innerHeight}
          numberOfPieces={200}
          gravity={0.05}
          recycle={false}
          initialVelocityY={15}
          colors={['#8CB3F3', '#CEA3FF', '#FA6F68', '#FBCB5F', '#A0C95D']}
          drawShape={ctx => {
            const width = 15;
            const height = 8;
            const radius = 3;
            ctx.beginPath();
            ctx.moveTo(radius, 0);
            ctx.arcTo(width, 0, width, height, radius);
            ctx.arcTo(width, height, 0, height, radius);
            ctx.arcTo(0, height, 0, 0, radius);
            ctx.arcTo(0, 0, width, 0, radius);
            ctx.closePath();
            ctx.fill();
          }}
        />
        </div>
      )}
        


     <AbajoJuegos idJuegoAct={3} diaActual={parseInt(params.dia!)}></AbajoJuegos>

    </div>
  );
}


export default Sudoku;
